import { render, staticRenderFns } from "./ApprovalFlowStatus.vue?vue&type=template&id=3194dd5c&scoped=true&"
import script from "./ApprovalFlowStatus.vue?vue&type=script&lang=js&"
export * from "./ApprovalFlowStatus.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalFlowStatus.vue?vue&type=style&index=0&id=3194dd5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3194dd5c",
  null
  
)

export default component.exports